module.exports = __webpack_public_path__ + "static/img/logo_login.df8261f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_login.png
// module id = 7AYN
// module chunks = 1